export default __webpack_public_path__ + "static/kv-logo-m-cht-2f0c5ce35b8480e8304439c636312d6f.png";